import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import AnimatedRoutes from './Components/AnimatedRoutes';
import { DarkModeContext } from './context/darkModeContext';
import { AuthContextProvider } from './context/AuthContext';

function App() {
  const { darkMode } = useContext(DarkModeContext);

  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => {
    if (window.innerWidth < 956) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
  }, []);

  return (
    <AuthContextProvider>
      <AppStyled>
        <div className={darkMode ? 'app dark' : 'app'}>
          <AnimatedRoutes isMobile={isMobile} />
        </div>
      </AppStyled>
    </AuthContextProvider>
  );
}

const AppStyled = styled.div`
  .app {
    transition: all 0.3s ease-in-out;
  }
  .app.dark {
    background-color: #111;
    color: #fff;
    transition: all 0.3s ease-in-out;
    label {
      color: #fff;
    }

    .grab-it {
      background-color: #111;
    }
    .item-title {
      color: #fff;
    }

    .icon {
      color: #fff;
    }

    .input-form {
      color: #333;
    }
    .notification-text {
      color: #fff;
    }
    .container {
      background-color: #111;
    }
    .social-icon {
      color: #fff;
      border: 1px solid #fff;
    }

    .social-icon:hover {
      color: #4481eb;
      border-color: #4481eb;
    }

    .btn {
      border: 1px solid #fff;
    }

    .title {
      color: #fff;
    }

    .chart-grid {
      stroke: rgba(228, 255, 255, 0.219);
    }

    .table {
      background-color: #111;
      .tableCell {
        color: #fff;
      }
    }

    .navbar {
      color: #fff;
      border-color: #333;
      .search {
        border-color: #999;
      }
    }

    .sidebar {
      background-color: #000;
      border-color: #333;

      .top {
        border-bottom: 0.5px solid #333;
        .logo {
          color: #999;
        }
      }
      hr {
        border-color: #333;
      }

      ul {
        li {
          &:hover {
            background-color: #333;
          }

          .icon {
            color: #999;
          }
        }
      }
    }
    .btn,
    .nav-text,
    .social-text,
    .panel-text,
    .css-i4bv87-MuiSvgIcon-root,
    .counter,
    .MuiSvgIcon-root,
    .MuiSvgIcon-fontSizeMedium,
    .css-i4bv87-MuiSvgIcon-root .link {
      color: #fff;
    }

    .amount-text {
      font-size: 3rem;
      color: var(--accent-blue);
    }
    .chart-text {
      color: var(--deep-blue);
    }

    .datatable {
      .datagrid {
        color: gray;
        border: none;

        .viewButton,
        .deleteButton,
        .updateButton,
        .cellWithStatus {
          color: #999;
          border: none;
        }
      }
    }
    .css-ptiqhd-MuiSvgIcon-root,
    .css-1md3f2f-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root,
    .css-194a1fa-MuiSelect-select-MuiInputBase-input.css-194a1fa-MuiSelect-select-MuiInputBase-input.css-194a1fa-MuiSelect-select-MuiInputBase-input,
    .form-input {
      color: #999;
    }

    input {
      background-color: transparent;
      color: #999;

      &:disabled {
        background-color: transparent;
        color: #999;
      }
    }
    p {
      color: #999;
    }

    h4 {
      color: #999;
    }
  }
`;

export default App;
